/**
 * Route Configuration
 * Centralized route definitions for the application
 */

export const ROUTES = {
  // Landing
  HOME: '/',
  PRIVACY_POLICY: '/privacy-policy',
  
  // API Documentation
  API_DOCS: '/otp/api-docs',
  
  // Auth Routes
  LOGIN: '/login',
  REGISTER: '/register',
  
  // Dashboard Routes
  DASHBOARD: '/dashboard',
  DASHBOARD_HOME: '/dashboard/home',
  API_KEYS: '/dashboard/api-keys',
  LOGS: '/dashboard/logs',
  PROFILE: '/dashboard/profile',
  BILLING: '/dashboard/billing',
  SEND_MESSAGE: '/dashboard/send-message',
  LINK_PHONE: '/dashboard/link-phone',
  
  // Admin Routes
  ADMIN: '/admin',
  ADMIN_HOME: '/admin/home',
  ADMIN_USERS: '/admin/users',
  ADMIN_BALANCE: '/admin/balance',
  ADMIN_PLANS: '/admin/plans',
  ADMIN_STATS: '/admin/stats',
  ADMIN_ACCOUNTS: '/admin/accounts',
};

export default ROUTES;
